import MyProLayout from "../../../components/MyProLayout";
import {ActionType, ProTable} from "@ant-design/pro-components";
import FetchUtil from "../../../utils/FetchUtil";
import CrawlerEditor from "../log/CrawlerEditor";
import React, {useRef} from "react";
import {useParams} from "react-router-dom";

const AiPrompt = () => {

    const {jobType} = useParams();
    const editorRef = useRef();
    const actionRef = useRef<ActionType>();

    const columns: any[] = [
        {
            title: 'ID',
            dataIndex: 'id',
            align: 'center' as 'center',
            width: 40,
        },
        {
            title: '任务名称',
            dataIndex: 'name',
            width: 200,
            render: (v: string, r: any) => <>{v} <br/>
                <span className="blue bold">[{r.serverId}]</span> <span className="green">{r.schedule}</span>
            </>,
            sorter: (a: any, b: any) => a.name.localeCompare(b.name),
        },
        ]

    return (
        <MyProLayout>

            <ProTable
                actionRef={actionRef}
                columns={columns}
                rowKey="id"
                cardBordered={true}
                pagination={{pageSize: 50}}
                request={async (
                    // params,
                    // sort,
                    // filter,
                ) => {
                    const res = await FetchUtil.awaitFetch('/pyApi/jobs/list', {jobType: jobType || "crawl"});
                    return {
                        success: true,
                        data: res.data?.list,
                    };
                }}
                search={false}
            />
            <CrawlerEditor ref={editorRef} callback={() => actionRef.current?.reload()}/>
        </MyProLayout>
    )
}

export default AiPrompt;
